import type { OptionGroup } from "@workspace/product-catalog-types";

/**
 * HA-1025 / D-HA-72 — a product with at least one required option group asks for its options when
 * it is tapped, before the line is added. A product with only optional groups, or none, is added
 * at once and its options changed from the line.
 */
export function needsOptionsOnAdd(groups: OptionGroup[] | undefined): boolean {
	return groups?.some((g) => g.isRequired) ?? false;
}
